module.exports = __webpack_public_path__ + "img/phi-logo-footer.288c27fa.svg";